export default __webpack_public_path__ + "static/media/shoppingbag.8a74825c.svg";